import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DateForm } from '../components/date';
import { ImageForm } from '../components/image';
import { LongTextForm } from '../components/longtext';
import { MapAttributionForm } from '../components/mapattribution';
import { MapForm } from '../components/map';
import { MapScaleForm } from '../components/mapscale';
import { MapScaleLineForm } from '../components/mapscaleline';
import { MapOverviewForm } from '../components/mapoverview';
import { RenderForm } from '../components/render';
import { TextForm } from '../components/text';
export class FormBuilder extends React.PureComponent {
    components = {
        DateForm,
        ImageForm,
        LongTextForm,
        MapAttributionForm,
        MapForm,
        MapScaleForm,
        MapScaleLineForm,
        MapOverviewForm,
        RenderForm,
        TextForm,
    };
    render() {
        return (_jsx("div", { className: 'sg-u-vs-2 sg-a-d-f sg-a-fd-c', children: Object.keys(this.props.components).map((componentId) => {
                const component = this.props.components[componentId], Component = this.components[`${component.type}Form`];
                if (!Component && component && component.editable) {
                    console.warn(`Repex: component type "${component.type}" not editable`);
                    return null;
                }
                return component && (component.editable || component.optional) ? (_jsx(Component, { componentIdent: componentId, isOptional: component.optional }, componentId)) : null;
            }) }));
    }
}
//# sourceMappingURL=formbuilder.js.map